import { render, staticRenderFns } from "./FieldItem.vue?vue&type=template&id=f08f90ea&"
import script from "./FieldItem.vue?vue&type=script&lang=js&"
export * from "./FieldItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports